import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link, useNavigate } from 'react-router-dom'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { FaProductHunt, FaRegHandPointRight, FaUser } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { addFormData } from '../utils/api';

const AddCategory = () => {
    const [validated, setValidated] = useState(false);
    const [values, setMember] = useState();
    const navigate = useNavigate();
    const centerid = localStorage.getItem('centerdata');

    useEffect(() => {
        if (centerid) {
            navigate('/add-member');
        }
        else {
            navigate("/");
        }
    }, [centerid]);

    const handleMemberSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        else {
            try {
                const memberdata = { centerid: centerid, mis_name: values.mis_name, mis_emp_id: values.mis_emp_id, mis_type: values.mis_type, mis_password: values.mis_password };
                addFormData('center-add-center-member-data', memberdata).then((res) => {
                    if (res.data.status === 1) {
                        toast.success("Member has been added successfully!");
                        navigate('/member');
                    }
                    else if (res.data.status === 2) {
                        toast.warning("This Member already exit!!");
                    }
                    else {
                        toast.error("Something Wrongs!!");
                    }
                })
            }
            catch (error) {
                toast.error("Something is worng!!");
            }
        }
        setValidated(true);
    };


    const handleInputs = e => {
        setMember({
            ...values,
            [e.target.name]: e.target.value,
        });
    };
    return (
        <div className="misDashboard">
            <Helmet>
                <title>SATKARTAR:WAREHOUSE::ADD CATEGORY</title>
            </Helmet>
            <ContentWrapper>
                <div className="page-wrapper breadcum">
                    <div className="page-breadcrumb btnbreadcrum d-none d-sm-flex align-items-center justify-between">
                        <div className="">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/dashboard">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item" aria-current="page">ADD MIS AND AMIS</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div className="col-6 col-lg-6 col-xl-6 card cardform">
                        <div className="card border-top border-0 border-4 border-danger">
                            <div className="card-body">
                                <div className="card-title d-flex align-items-center">
                                    <div className="form-heading">
                                        <FaUser className="formIcons" />
                                        <h5 className="mb-0 text-danger">ADD MIS AND AMIS</h5>
                                    </div>
                                </div>
                                <hr />
                                <Form noValidate validated={validated} onSubmit={handleMemberSubmit} method="post">
                                    <Row className="mb-3">
                                        <Form.Group as={Col} md="6" controlId="validationCustom01">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="Name"
                                                name="mis_name"
                                                onChange={handleInputs}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                <FaRegHandPointRight /> Please provide a valid name
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} md="6" controlId="validationCustom02">
                                            <Form.Label>EMP ID</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="Enter the emp id"
                                                name="mis_emp_id"
                                                pattern="[^\s]+"
                                                onChange={handleInputs}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                <FaRegHandPointRight /> Please provide a valid emp id without white space
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} md="6" controlId="validationCustom03">
                                            <Form.Label>Select Member Type</Form.Label>
                                            <Form.Select required
                                                placeholder="Member Type"
                                                name="mis_type"
                                                onChange={handleInputs}>
                                                <option value="">Select Member Type</option>
                                                <option value="MIS">MIS</option>
                                                <option value="AMIS">AMIS</option>
                                                <option value="VERIFIER">VERIFIER</option>
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                <FaRegHandPointRight /> Please provide a valid member
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} md="6" controlId="validationCustom04">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control
                                                required
                                                type="password"
                                                placeholder="Enter the password"
                                                name="mis_password"
                                                onChange={handleInputs}
                                                minLength={5}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                <FaRegHandPointRight /> Password should be minimum 5 characters
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Row>
                                    <Button type="submit">Submit</Button>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
}

export default AddCategory